import React, { useState, useEffect } from 'react';

const CirculationContext = React.createContext({
    REACT_APP_SmmDownload: ''
});
/**
 * 網站設定檔、全域變數
 * @param {any} props
 */
export const CirculationContextProvider = (props) => {

    const [events, setEvents] = useState({
        mode: 'wait',
        data: []
    });
    function SmmDBApi() {

        var url = 'react_app_circulation_config';
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .then(data => {
                setEvents({
                    mode: 'ok',
                    data: data
                });
            })
            .catch(e => {
                console.log(e);
            });
    }
    useEffect(function () {
        if (events.mode == 'wait')
            SmmDBApi();
    }, [events]);


    if (events.mode == 'ok') {
        return (
            < CirculationContext.Provider
                // 記得提供 context 給 Provider
                value={{
                    REACT_APP_SmmDownload: events.data.react_APP_SmmDownload,
                    Last_Update: events.data.last_Update
                }}>

                {props.children}
            </ CirculationContext.Provider>
        );
    }
}

export default CirculationContext;